<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <PermissionDataTableRow
              :props="props"
            />
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PermissionDataTableRow from '../../components/PermissionDataTableRow'
import MassActionSelect from '../../../../vuetify-console/components/MassActionSelect'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('authentication/permissions')

export default {
  name: 'PermissionList',

  components: {
    MassActionSelect,
    PermissionDataTableRow
  },

  actionBar () {
    return {
      title: 'Permissions',
      actions: [
        {
          text: 'Add new Permission',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: []
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Name'), value: 'name', sortable: true },
        { text: this.$t('Code'), value: 'code', sortable: true },
        { text: this.$t('Scope'), sortable: false }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    onActionAdd () {
      this.$router.push({ name: 'single_permission', params: { id: '__' } })
    }
  }
}
</script>
